import React, { FC } from "react";
import { ICompanyPresentation } from "src/@types/clones";
import { getFileExtension } from "./utils/getFileExtension";
import { getPresentationIcon } from "./constants";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as DownloadIcon } from "src/assets/icons/download.svg";
import { Link } from "src/components/Link";
import { getImageUrl } from "src/utils/getImageUrl";

interface Props extends ICompanyPresentation {}

export const PresentationCard: FC<Props> = ({ file, title }) => {
  const fileExt = getFileExtension(file);
  const Icon = getPresentationIcon(fileExt);

  return (
    <div className="border border-black-base/20 min-h-48 rounded-20 py-6 px-3  w-full flex flex-col gap-5 items-center justify-between">
      <Icon className="w-15 h-15 text-purple-base" title={fileExt} />
      <h5
        className="text-sm line-clamp-2 break-all font-medium text-center"
        title={title}
      >
        {title}
      </h5>

      <Link
        className="w-full"
        href={getImageUrl(file)}
        isExternalLink
        isOpenNewTab
      >
        <Button
          className="flex flex-row gap-1 px-4 py-2 w-full"
          variant={ButtonVariants.SECONDARY}
        >
          <DownloadIcon />
          <span>View</span>
        </Button>
      </Link>
    </div>
  );
};
